<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";
import VueMonthlyPicker from 'vue-monthly-picker'
import moment from 'moment';

export default {
  locales: {
    pt: {
      Sponsored: "Indicados",
      Username: "Usuário",
      Name: "Nome",
      Date: "Data",
      "E-mail": "E-mail",
      Cellphone: "Celular",
      Plan: "Plano",
      Status: "Status",
      Qualified: "Qualificado",
      Unqualified: "Não Qualificado",
      Left: "Esquerdo",
      Right: "Direito",
      Pending: "Pendente",
      Approved: "Aprovado",
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.",
      "No records found.": "Nenhum registro encontrado.",
      Graduation: "Graduação",
    },
    es: {
      Sponsored: "Patrocinados",
      Username: "Nombre de Usuario",
      Name: "Nombre",
      Date: "Data",
      "E-mail": "E-mail",
      Cellphone: "Celular",
      Plan: "Plano",
      Status: "Status",
      Qualified: "Calificado",
      Unqualified: "No Cualificado",
      Left: "Izquierdo",
      Right: "Derecho",
      Pending: "Pendiente",
      Approved: "Aprobado",
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtelo de nuevo más tarde.",
      "No records found.": "No se encontraron registros.",
      Graduation: "Graduación",
    },
  },
  components: {
    Layout,
    Stat,
    VueMonthlyPicker,
  },
  data() {
    return {
      calendar: "",
      monthly: {
        placeHolder: moment().format('MMM/YYYY'),
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      },
      date: moment().format('YYYY-MM'),

      table: {
        heade: [
          "Username",
          "Name",
          "Total de Pontos",
          "Pontos Aproveitados",
        ],
        body: null,
        loading: true,
      },

      statData: null,

      graduation: {
        previous: '-',
        points: '0',
        next: '-',
        percent: 0
      },
    };
  },
  methods: {
    getUnilevel() {
      this.table.body = null;

      api
        .get("network/unilevel?date=" + this.date)
        .then((response) => {
          if (response.data.status == "success") {
            this.table.body = response.data.list;

            this.statData = [
              {
                type: "line",
                icon: "bxs-graduation",
                title: "Graduação",
                value: response.data.graduation.name,
              },
              {
                type: "line",
                icon: "bx-user",
                title: "Pontos Pessoais",
                value: this.$options.filters.points(response.data.graduation.points.personal)
              },
              {
                type: "line",
                icon: "bx-bar-chart-square",
                title: "Pontos Aproveitados",
                value: this.$options.filters.points(response.data.graduation.points.used)
              },
              {
                type: "line",
                icon: "bx-chart",
                title: "Pontos Totais",
                value: this.$options.filters.points(response.data.graduation.points.total)
              }
            ]

            if (response.data.graduation.next) {
              this.graduation.previous = response.data.graduation.name
              this.graduation.points = response.data.graduation.points.used
              this.graduation.next = response.data.graduation.next.name
              this.graduation.percent = ((response.data.graduation.points.used - response.data.graduation.previous.points) * 100) / (response.data.graduation.next.points - response.data.graduation.previous.points)
            } else {
              this.graduation.previous = response.data.graduation.name
              this.graduation.points = response.data.graduation.points.used
              this.graduation.next = '-'
              this.graduation.percent = 100
            }
          }
        })
        .catch(() => {
          this.table.body = [];
        })
    },
  },
  mounted() {
    this.getUnilevel();
  },
  watch: {
    calendar: function (v) {
      this.date = moment(v._d).format('YYYY-MM')
      this.getUnilevel()
    }
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Rede</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Unilevel') }}</h3>
        <p></p>
      </div>
      <vue-monthly-picker v-model="calendar" dateFormat="MMM/YYYY" :placeHolder="monthly.placeHolder" :monthLabels="monthly.labels" :clearOption="false" alignment="center"></vue-monthly-picker>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-3">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div v-if="table.body" class="card">
      <div class="card-body">
        <b-progress style="border-radius: 3px;" :value="Number(graduation.percent)" variant="default" height="15px"></b-progress>
        <div class="d-flex justify-content-between">
          <div>
            {{ graduation.previous }}
          </div>
          <div class="text-center">
            {{ graduation.percent.toFixed(2) }}%
          </div>
          <div>
            {{ graduation.next }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="!table.body" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="table.body && table.body.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          nenhum registro encontrado
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead class="thead-light">
              <tr>
                <th v-for="th in table.heade" :key="th">{{ t(th) }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(td, index) in table.body" :key="index">
                <td v-for="(data, row) in td" :key="row">
                  <div v-if="row === 'avatar'">
                    <img v-if="data" class="rounded-circle header-profile-user" :src="data" alt="" style="width: 40px; height: 40px" />
                    <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=51722B&color=fff&name=' +
                      td.name
                      " alt="" style="width: 40px; height: 40px" />
                  </div>
                  <div v-else-if="row === 'total'">
                    {{ td.total | points }}
                  </div>
                  <div v-else-if="row === 'vml'">
                    {{ td.vml | points }}
                  </div>
                  <div v-else class="notranslate">
                    {{ data }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>
